import { motion } from "framer-motion";
import { LEAKS } from "../lib/site";

const MODULES = ["CRM & DATA", "SALES FUNNEL", "MARKETING", "QUOTES & PROPOSALS", "CUSTOMERS", "VENDOR SPEND"];

const Leakage = () => (
    <div className="scan-sweep relative rounded-2xl border border-white/10 bg-ink2 p-6 sm:p-8" data-testid="leakage-visual">
        <div className="flex items-center justify-between gap-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-cloud">The business you already have</p>
            <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.24em] text-vantera">
                <span className="inline-block size-1.5 rounded-full bg-vantera animate-blink" /> Scanning
            </p>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3">
            {MODULES.map((m, i) => (
                <motion.div
                    key={m}
                    initial={{ opacity: 0, y: 14 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: i * 0.1 }}
                    className="relative rounded-lg border border-white/10 bg-white/[0.03] p-4"
                >
                    <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-ivory/80">{m}</p>
                    <div className="mt-3 flex items-end gap-1" aria-hidden="true">
                        {[14, 22, 9, 18, 12].map((h, j) => (
                            <motion.span key={j} className="w-full max-w-[14px] rounded-t-[2px] bg-vantera/25" initial={{ height: 0 }} whileInView={{ height: h }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.3 + i * 0.1 + j * 0.06 }} />
                        ))}
                    </div>
                    <span className="absolute right-3 top-3 flex size-2" aria-hidden="true">
                        <span className="absolute inline-flex size-full animate-ping rounded-full bg-rose-400 opacity-60" />
                        <span className="relative inline-flex size-2 rounded-full bg-rose-400" />
                    </span>
                    <p className="mt-2 font-mono text-[9px] uppercase tracking-[0.2em] text-rose-300/80">Leak detected</p>
                </motion.div>
            ))}
        </div>

        <div className="mt-8 border-t border-white/10 pt-6">
            <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-cloud">Where it leaks</p>
            <div className="mt-4 grid gap-x-8 gap-y-2.5 sm:grid-cols-2">
                {LEAKS.map((l, i) => (
                    <motion.p
                        key={l}
                        initial={{ opacity: 0, x: -14 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.2 + i * 0.07 }}
                        className="flex items-center gap-3 text-[15px] text-ivory/90"
                    >
                        <span className="font-mono text-[10px] text-rose-300/90">{String(i + 1).padStart(2, "0")}</span>
                        <span className="h-px w-5 bg-rose-400/50" aria-hidden="true" />
                        {l}
                    </motion.p>
                ))}
            </div>
        </div>
    </div>
);

export default Leakage;